export enum Languages {
  DE = 'de',
  EN = 'en'
}
